import axios from 'axios';
import sissconst from './sissconst';
import Vue from 'vue';
import Util from "@/lib/utils";
import { Toast } from "vant";
Vue.use(Toast);
const modeUrlObj = {
  //本地开发 运行：npm run serve:local   打包：npm run build:local
  'local': {
    apiUrl: "http://localhost:21021"
  },
  // 线上242服务器开发环境 运行：npm run serve:dev   打包：npm run build:dev
  'development': {
    apiUrl: "https://storeapiv3.sissyun.com.cn"
  },
  // 线上测试环境 运行：npm run serve:test   打包：npm run build:test
  'test': {
    apiUrl: "https://teststoreapiv3.sissyun.com.cn"
  },
  //预发布版环境
  'beta': {
    apiUrl: "http://127.0.0.1:21021"
  },
  // 生产环境 运行：npm run serve:pro   打包：npm run build:pro
  'production': {
    apiUrl: "https://shop3.sissyun.com.cn"

  },
  // 线上242服务器开发环境 运行：npm run serve:dev   打包：npm run build:dev
  'huidudevelopment': {
    apiUrl: "https://storeapiv3-hd.sissyun.com.cn"
  },
  // 线上测试环境 运行：npm run serve:test   打包：npm run build:test
  'huidutest': {
    apiUrl: "https://testministore-hd.sissyun.com.cn"
  },
  // 生产环境 运行：npm run serve:pro   打包：npm run build:pro
  'huiduproduction': {
    apiUrl: "https://shop3-hd.sissyun.com.cn"

  },
}
const ajax = axios.create({
  baseURL: modeUrlObj[process.env.VUE_APP_CURENV].apiUrl,
  timeout: 30000,
});
ajax.interceptors.request.use((config) => {
  if (!!window.siss.auth.getToken()) {
    config.headers.common.Authorization = 'Bearer ' + window.siss.auth.getToken();
  }
  return config;
}, (err) => {
  Toast.fail(JSON.stringify(err));
  return err;
});
ajax.interceptors.response.use((res) => {
  return res;
}, async (err) => {
  if (!!err.response && err.response.status == 401) {
    Toast.fail('授权失效，正在尝试登陆')
    const openid = siss.utils.getQueryString('openid') || siss.utils.getCookieValue('User_Ticket');
    const obj: any = { openid: openid, type: '2' }
    ajax.post('/api/TokenAuth/AuthenticateMobile', obj).then(res => {
      const tokenExpireDate = new Date(new Date().getTime() + 1000 * res.data.result.expireInSeconds);
      siss.auth.setToken(res.data.result.accessToken, tokenExpireDate);
      siss.utils.setCookieValue(sissconst.authorization.encrptedAuthTokenName, res.data.result.encryptedAccessToken, tokenExpireDate, siss.sissPath);
      location.reload(false)
    });
    let param = await Util.buildLoginLog()
    console.log('param===', param)
    ajax.get('/minimall/statistics-service/log.gif', {params: param}).then(res => {
      console.log(res)
    })
  }
  // if (err.code === 'ECONNABORTED' && err.message.indexOf('timeout') !== -1) {
  //     Toast.fail('连接超时，请重试！');
  // } else {
  //     Toast.fail('网络异常，请重试');
  // }
  return err;
});
export default ajax;
